import { Component, Vue, Prop } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect'

@Component({
  components: {
    Multiselect,
  }
})

export default class AddGoogleCertificate extends Vue {

  private namespace: string = '/Console';

  private uploadedCertificate: any = null;

  private alertMessage: string = '';

  private error: boolean = false;

  @Prop()
  private clientEmailsAndIds?: {label: string, clientId: string}[];

  @Prop()
  private imported?: boolean;

  private existingCertificates: {label: string, clientId: string}[] | null = null;

  private get ClientEmailsAndIds () {

    if (this.clientEmailsAndIds != undefined) {

      this.existingCertificates = this.clientEmailsAndIds;

      return this.existingCertificates;
    }

    return undefined;
  }

  private get enabled () {

    return this.uploadedCertificate != null;
  }

  mounted () {

    if (this.ClientEmailsAndIds === undefined) {

      return this.getCertificates();
    }

  }

  private async getCertificates () {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/ClientCertificates`);
      
      this.existingCertificates = response.data.map((client: {clientEmail: string, clientId: string}) => {
        return {label: client.clientEmail, clientId: client.clientId}
      });
    } catch (err) {

      console.error(err);
    }
  }

  alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async addCertificate () {

    const formData: any = new FormData();
    formData.append('File', this.uploadedCertificate, this.uploadedCertificate.name);

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/AddGoogleApiCertificate`, formData, {
        headers: {'Content-Type': 'multipart/form-data'}
      });
    
     this.alertMessage = 'Certificate successfuly submited.';
     this.alertReset();

    } catch (err) {

     this.error = !this.error;
     this.alertMessage = 'Something went wrong.';
     this.alertReset();
    }
  }

  private handleFileUpload () {

    const certificate = this.$refs.certificate as HTMLInputElement;
    const input = this.$refs.certificateInput as HTMLInputElement;

    if (certificate.files != null) {

      this.uploadedCertificate = certificate.files[0];
      input.value = this.uploadedCertificate.name;
    }
  }
}